import { CircleAlert } from 'lucide-react';
import {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  EmptyDescription,
  Button,
} from '@herit-fe/heritage-ui';
import { UI_TEXT } from '@/shared/languages';

export interface ErrorStateProps {
  /** 제목 — 기본 "데이터를 불러오지 못했습니다". */
  title?: string;
  /** 보조 설명(선택). */
  description?: string;
  /** 재시도 핸들러 — 보통 RQ `refetch`. 없으면 버튼 미노출. */
  onRetry?: () => void;
}

/**
 * 국소 데이터 로드 실패 표준 상태 — 데이터 영역을 채우는 에러 UI(heritage `Empty` 합성). 전역
 * 401·503·네트워크는 axios 인터셉터가 따로 처리하고, 이건 그 외 개별 query 실패용. 데이터 소유자
 * (widget·entity-UI)가 `isError` 분기에서 렌더하고 `onRetry`={refetch} 로 재시도시킨다.
 */
export function ErrorState({
  title = UI_TEXT.ERROR_CRITICAL_TITLE,
  description,
  onRetry,
}: ErrorStateProps) {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <CircleAlert />
        </EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        {description ? <EmptyDescription>{description}</EmptyDescription> : null}
      </EmptyHeader>
      {onRetry ? (
        <Button variant="outline" size="sm" onClick={onRetry}>
          {UI_TEXT.COMMON_RETRY}
        </Button>
      ) : null}
    </Empty>
  );
}
